import axios from "axios";

import { unauthorizedInterceptors } from "../utilities/functions";
// Create API instance for mailing response
const mailingResponseAPI = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/mediaplan/api/media-plan-list-segments-response`,
  headers: {  
    "Content-Type": "application/json",
  },
});
unauthorizedInterceptors(mailingResponseAPI);
// Set auth header for all requests
const setAuthHeader = () => {
  const token = localStorage.getItem("token");
  if (token) {
    mailingResponseAPI.defaults.headers.common["Authorization"] = `Token ${token}`;
  }
};

/**
 * Get mailing response data for a media plan
 * @param {number} mediaPlanId - ID of the media plan
 * @returns {Promise} - Promise with mailing response data
 */
export const getMailingResponseByMediaPlan = async (mediaPlanId) => {
  console.log(mediaPlanId, " mediaPlanId getMailingResponseByMediaPlan");
  setAuthHeader();
  return await mailingResponseAPI.get(`/?media_plan=${mediaPlanId}`);
};

/**
 * Get mailing response data for a specific campaign code
 * @param {string} campaignCode - Campaign code
 * @returns {Promise} - Promise with mailing response data
 */
export const getMailingResponseByCampaignCode = async (campaignCode) => {
  console.log(campaignCode, " campaignCode getMailingResponseByCampaignCode");
  setAuthHeader();
  return await mailingResponseAPI.get(`/?campaign_code=${campaignCode}`);
};

/**
 * Get mailing response data with filtering options
 * @param {Object} options - Filter options
 * @param {number} [options.mediaPlanId] - Media plan ID
 * @param {string} [options.campaignCode] - Campaign code
 * @param {number} [options.listId] - List ID
 * @param {number} [options.segmentId] - Segment ID
 * @param {string} [options.sourceCode] - Source code
 * @param {string} [options.startDate] - Start date (YYYY-MM-DD)
 * @param {string} [options.endDate] - End date (YYYY-MM-DD)
 * @returns {Promise} - Promise with mailing response data
 */
export const getMailingResponseData = async ({mediaPlanId}) => {
  setAuthHeader();
  
  // Check if mediaPlanId is defined before making the API call
  if (!mediaPlanId) {
    console.warn('getMailingResponseData called with undefined mediaPlanId');
    return { data: { results: [] } }; // Return empty results to avoid errors in the component
  }
  
  return await mailingResponseAPI.get('/?media_plan=' + mediaPlanId);
};
